'use client'

import React, { useState } from 'react'
import classNames from 'classnames'
import {
  getProductUrl,
  getRelativeProductImageUrl,
} from '@dustin-web/microsite-components/src/utils/urls'
import { Image } from '@dustin-web/microsite-components/src/image/image'
import { TicketLink } from '../ticket-link'
import { Skeleton } from '@dustin-web/microsite-components/src/skeleton'
import { ProductTypeProps, Maybe } from '../cards'
import EnergyLabel from '../energy-label'

export type Props = {
  className?: string
  product?: Maybe<ProductTypeProps>
  ticket: string
  showEnergyLabel?: boolean
  priority?: boolean
  imageWidth?: number
  imageHeight?: number
  onClickProduct: () => void
  productImageUrlOverride?: string
  useAnchorTag?: boolean
}

const ProductCardImage = ({
  className,
  product,
  ticket,
  showEnergyLabel = false,
  imageWidth = 64,
  imageHeight = 64,
  priority = false,
  onClickProduct,
  productImageUrlOverride,
  useAnchorTag = false,
}: Props) => {
  const [showSkeleton, setShowSkeleton] = useState(true)

  if (!product) {
    return null
  }

  const productUrl = getProductUrl(product.id, product.nameSlug)

  const isSkeletonIsEnabled = !priority && showSkeleton

  return (
    <figure className={classNames('c-product-card-image', className)}>
      {product.internalProduct && <div className="internal-product">Internflaggad</div>}
      {isSkeletonIsEnabled && <Skeleton width={imageWidth} height={imageHeight} withLogo />}
      <TicketLink
        url={productUrl}
        ticket={ticket}
        onClickCallBack={onClickProduct}
        useAnchorTag={useAnchorTag}>
        <div
          className={isSkeletonIsEnabled ? 'u-absolute u-opacity-0' : ''}
          style={{ fontSize: 0 }}>
          <Image
            src={
              productImageUrlOverride ||
              getRelativeProductImageUrl(
                product.primaryImageId ?? '',
                imageWidth * 3,
                imageHeight * 3,
                `${product.manufacturerName} ${product.displayName} ${product.displaySpecifications}`
              )
            }
            alt={`${product.manufacturerName} ${product.displayName} ${product.displaySpecifications}`}
            width={imageWidth}
            height={imageHeight}
            priority={priority}
            onLoad={() => setShowSkeleton(false)}
          />
        </div>
      </TicketLink>
      {showEnergyLabel && (
        <EnergyLabel
          energyClass={product.energyClass}
          energyDocumentId={product.energyDocumentId}
          energyLabelImageId={product.energyLabelImageId}
          productId={product.id}
          nameSlug={product.nameSlug}
          productTitle={`${product.manufacturerName} ${product.displayName} ${product.displaySpecifications}`}
          width={45}
          className="c-product-card__energy-label"
        />
      )}
    </figure>
  )
}

export default ProductCardImage
